'use client';

import UserManagement from '@/features/user-management/components/UserManagement';

export default function UserManagementPage() {
  return <UserManagement />;
}
